'use es6';

import { List } from 'immutable';
import { Filter } from '../../../config/filters';
export default ((config, engagementType) => config.updateIn(['filters', 'custom'], List(), customFilters => customFilters.push(Filter({
  property: 'hs_engagement_type',
  operator: 'IN',
  values: [engagementType]
}))));